export const SEAT_BOOKING_START_HOUR_OFFSET = 9;
export const SEAT_BOOKING_END_HOUR_OFFSET = 17;
export const OPEN_WORKSPACE_LANDING_PATH = '/home/openworkspace';
